import { bool } from "yup";
import { userInfoValidationSchema } from "./userInfoValidationSchema";

export const becomeReferralValidationSchema = userInfoValidationSchema.pick(["referral"]).shape({
    acceptTerms: bool().required().oneOf([true]),
});
